// ============================================================================
// STATUS:FIXED - Keeps all existing exports + adds Admin Note
// CHANGES: 
//   1. Added adminNoteItem constant
//   2. Added adminNoteItem to itemsToRender
//   3. Added onOpenAdminNote prop handling
//   4. KEPT all existing exports (adminItems, menuItems, etc.)
// ============================================================================
import React from "react";
import { Menu } from "antd";
import { FormattedMessage } from "react-intl";

// ============================================================================
// Operational statuses the admin can manually assign to an order
// ============================================================================
export const UPDATE_STATUS_OPTIONS = [
  { label: "Assigned", value: "assigned" },
  { label: "Picked Up", value: "pickup_completed" },
  { label: "In Transit", value: "in_transit" },
  { label: "In Delivery", value: "in_delivery" },
  { label: "Arrived", value: "arrived" },
];

// ============================================================================
// EXISTING EXPORTS - Keep these as they're used elsewhere
// ============================================================================
export const deleteItem = {
  messageId: "tabPane.actions.delete",
  type: "delete",
  buttonId: "order-delete",
  defaultMessage: "Delete",
};

export const returnItem = {
  messageId: "tabPane.actions.return",
  type: "return",
  defaultMessage: "Return",
};

export const restoreItem = {
  messageId: "tabPane.actions.restore",
  type: "restore",
  defaultMessage: "Restore",
};

export const restoreFailedItem = {
  messageId: "tabPane.actions.restore",
  type: "restoreFailed",
  defaultMessage: "New",
};

export const journeyView = {
  messageId: "tabPane.actions.history",
  type: "journeyView",
  defaultMessage: "Check history",
};
// export const returnFormView = {
//   messageId: "tabPane.actions.returnFormView",
//   type: "returnFormView",
//   defaultMessage: "Download Form",
// };

export const returnToShipper = {
  messageId: "tabPane.actions.returnToShipper",
  type: "returnToShipper",
  defaultMessage: "Return to shipper",
};
export const returnToShipperChargeable = {
  messageId: "tabPane.actions.returnToShipperChargeable",
  type: "returnToShipperChargeable",
  defaultMessage: "Return to Shipper Chargeable (RTSC)",
};

export const cancelCompleted = {
  messageId: "tabPane.actions.cancelCompleted",
  type: "cancelCompleted",
  defaultMessage: "Cancel Completed Order",
};

// ============================================================================
//  NEW: Admin Note Item
// ============================================================================
export const adminNoteItem = {
  messageId: "tabPane.actions.adminNote",
  type: "adminNote",
  buttonId: "order-admin-note",
  defaultMessage: "Admin Note",
};

// ============================================================================
// EXISTING EXPORTS - Keep these arrays as they're used elsewhere
// ============================================================================
export const menuItems = [
  {
    messageId: "tabPane.actions.cancel",
    type: "cancel",
    defaultMessage: "Cancel",
  },
  {
    messageId: "tabPane.actions.postpone",
    type: "postpone",
    defaultMessage: "Postpone",
  },
  deleteItem,
];

export const adminItems = [
  {
    messageId: "tabPane.actions.removeLocation",
    type: "removeLocation",
    defaultMessage: "Remove location",
  },
  {
    messageId: "tabPane.actions.completeOrder",
    type: "completeOrder",
    defaultMessage: "Complete order",
  },
  journeyView,
];

// ============================================================================
// DropdownMenu Component
// ============================================================================
function DropdownMenu({
  id,
  onSetModal,
  isAdminOrders,
  providedItems,
  isReturn,
  onOpenAdminNote,
  onUpdateStatus,   // handler: (orderId, targetStatus) => void
  currentStatus,    // current order status — excluded from submenu options
}) {
  // ============================================================================
  // Build items to render
  // ============================================================================
  let itemsToRender = [];
  
  if (providedItems && providedItems.length > 0) {
    // If specific items are provided, use them
    itemsToRender = [...providedItems];
  } else {
    // Otherwise, build default items
    itemsToRender = [...menuItems];
    if (isAdminOrders) {
      itemsToRender.push(...adminItems);
    }
  }
  
  // ============================================================================
  // ALWAYS add Admin Note item at the end (for ALL orders)
  // ============================================================================
  if (onOpenAdminNote) {
    itemsToRender.push(adminNoteItem);
  }

  // ============================================================================
  // "Update Status" shows all statuses except the current one
  // ============================================================================
  const statusOptions = isAdminOrders && onUpdateStatus
    ? UPDATE_STATUS_OPTIONS.filter((opt) => opt.value !== currentStatus)
    : [];

  // ============================================================================
  // Render Menu
  // ============================================================================
  return (
    <Menu>
      {itemsToRender.map(({ messageId, type, buttonId, defaultMessage }) => (
        <Menu.Item
          id={buttonId}
          onClick={(e) => {
            if (type === "adminNote") {
              if (onOpenAdminNote) onOpenAdminNote(id);
              return;
            }
            onSetModal({
              type,
              id,
              open: ["journeyView"].includes(type) ? false : true,
            });
          }}
          key={messageId + id}
        >
          <FormattedMessage id={messageId} defaultMessage={defaultMessage} />
        </Menu.Item>
      ))}

      {/* ================================================================
          Update Status submenu — visible to admins only
          ================================================================ */}
      {statusOptions.length > 0 && (
        <Menu.SubMenu key={`updateStatus-${id}`} title="Update Status">
          {statusOptions.map((opt) => (
            <Menu.Item
              key={`status-${opt.value}-${id}`}
              onClick={() => onUpdateStatus(id, opt.value)}
            >
              {opt.label}
            </Menu.Item>
          ))}
        </Menu.SubMenu>
      )}
    </Menu>
  );
}

export default DropdownMenu;
